import { EnumAgentUserStatus } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/SwapAgent';

export const getAgentStatusDisplayValue = (status: number) => {
  const value = EnumAgentUserStatus[status];

  return String(value);
};
